import {
  createRouter,
  createWebHistory
} from 'vue-router'
import Layout from '@/layout'
// import home from '@/views/HomeView'

export const constantRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import('@/views/redirect/index')
    }]
  },
  // 不會開放給一般web user，只有後台有超連結
  {
    path: '/billboard/class-room/horizontal/:id',
    name: 'BillboardClassRoomHorizontal', // 教室看版-橫向
    component: () => import('@/views/billboard/class-room/Horizontal'),
    meta: { title: '教室看版-橫向', needLogin: false }
  },
  {
    path: '/billboard/class-room/vertical/:id',
    name: 'BillboardClassRoomVertical', // 教室看版-直向
    component: () => import('@/views/billboard/class-room/Vertical'),
    meta: { title: '教室看版-直向', needLogin: false }
  },
  {
    path: '/billboard/place/horizontal',
    name: 'BillboardPlaceHorizontal', // 場地看版-橫向
    component: () => import('@/views/billboard/place/Horizontal'),
    meta: { title: '場地看版-橫向', needLogin: false }
  },
  {
    path: '/billboard/place/vertical',
    name: 'BillboardPlaceVertical', // 場地看版-直向
    component: () => import('@/views/billboard/place/Vertical'),
    meta: { title: '場地看版-直向', needLogin: false }
  },
  //契約
  {
    path: '/contract/:id',
    name: 'Contract', // 契約
    component: () => import('@/views/contract'),
    meta: { title: '契約', needLogin: false }
  },
  {
    path: '/billboard/courtorder/horizontal/:id',
    name: 'BillboardCourtOrderHorizontal', // 場地租借狀況看版-橫向
    component: () => import('@/views/billboard/courtorder/Horizontal'),
    meta: { title: '場地租借狀況看版-橫向', needLogin: false }
  },
  {
    path: '/billboard/courtorder/vertical/:id',
    name: 'BillboardCourtOrderVertical', // 場地租借狀況看版-直向
    component: () => import('@/views/billboard/courtorder/Vertical'),
    meta: { title: '場地租借狀況看版-直向', needLogin: false }
  },
  {
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home'),
        meta: { title: '首頁', needLogin: false, needFooter: true }
      },
      {
        path: '/privacy-policy',
        name: 'PrivacyPolicy', // 會員隱私權條款
        component: () => import('@/views/policy/PrivacyPolicy'),
        meta: { title: '會員隱私權條款', needLogin: false, needFooter: true }
      }, {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/account/login'),
        meta: { title: '登入', needLogin: false }
      },
      {
        path: '/sign-up',
        name: 'SignUp', // 註冊
        component: () => import('@/views/account/sign-up'),
        meta: { title: '註冊', needLogin: false }
      },
      {
        path: '/sign-up/success',
        name: 'SignUpSuccess', // 註冊成功
        component: () => import('@/views/account/sign-up/Success'),
        meta: { title: '註冊成功', needLogin: false }
      },
      // 登入後個人頁
      {
        path: '/member',
        name: 'Member', // 個人資料、公司資料
        component: () => import('@/views/member'),
        meta: { title: '我的列表', needLogin: true, needFooter: true }
      },
      {
        path: '/member/profile-info',
        name: 'MemberProfileInfo', // 個人資料
        component: () => import('@/views/member/personal-info/Profile'),
        meta: { title: '個人資料', needLogin: true }
      },
      {
        path: '/member/company-info',
        name: 'MemberCompanyInfo', // 公司資料
        component: () => import('@/views/member/personal-info/Company'),
        meta: { title: '公司資料', needLogin: true }
      },
      {
        path: '/member/coaching-sessions',
        name: 'MemberCoachingSessions', // 我的課程列表
        component: () => import('@/views/member/coaching-sessions'),
        meta: { title: '我的課程列表入', needLogin: true }
      },
      {
        path: '/member/coaching-sessions/course-info/:id',
        name: 'MemberCoachingSessionsCourseInfo', // 我的課程學員名單
        permit: true,
        component: () => import('@/views/member/coaching-sessions/CourseInfo'),
        meta: { title: '我的課程學員名單', needLogin: true }
      },
      {
        path: '/member/calendar',
        name: 'MemberCalender', // 我的行事曆
        component: () => import('@/views/member/Calender'),
        meta: { title: '我的行事曆', needLogin: true }
      },
      {
        path: '/member/single-pass',
        name: 'MemberSinglePass', // 我的票卡-單次票
        component: () => import('@/views/member/tickets/SinglePass'),
        meta: { title: '我的單次票', needLogin: true }
      },
      {
        path: '/member/monthly-pass',
        name: 'MemberMonthlyPass', // 我的票卡-月票
        component: () => import('@/views/member/tickets/MonthlyPass'),
        meta: { title: '我的月票', needLogin: true }
      },
      {
        path: '/member/multi-use-pass',
        name: 'MemberMultiUsePass', // 我的票卡-回數票
        component: () => import('@/views/member/tickets/MultiUsePass'),
        meta: { title: '我的回數票', needLogin: true }
      },
      {
        path: '/member/periodical',
        name: 'MemberPeriodical', // 我的課程-定期課
        component: () => import('@/views/member/courses/Periodical'),
        meta: { title: '我的課程', needLogin: true }
      },
      {
        path: '/member/class',
        name: 'MemberClass', // 我的課程-堂數課
        component: () => import('@/views/member/courses/Class'),
        meta: { title: '我的課程', needLogin: true }
      },
      {
        path: '/member/ad-hoc-rental',
        name: 'MemberAdHocRental', // 場地租用-臨租
        component: () => import('@/views/member/courts/AdHocRental'),
        meta: { title: '場地租用', needLogin: true }
      },
      {
        path: '/member/seasonal-rental',
        name: 'MemberSeasonalRental', // 場地租用-季租
        component: () => import('@/views/member/courts/SeasonalRental'),
        meta: { title: '場地租用', needLogin: true }
      },
      {
        path: '/member/project-booking',
        name: 'MemberProjectBooking', // 場地租用-專案預約
        component: () => import('@/views/member/courts/ProjectBooking'),
        meta: { title: '場地租用', needLogin: true }
      },
      {
        path: '/member/prd',
        name: 'MemberPrd', // 我的商品
        component: () => import('@/views/member/Product'),
        meta: { title: '我的商品', needLogin: true }
      },
      {
        path: '/member/course-points',
        name: 'MemberCoursePoints', // 我的點數-課程點數
        component: () => import('@/views/member/points/CoursePoints'),
        meta: { title: '可用點數', needLogin: true }
      },
      {
        path: '/member/loyalty-points',
        name: 'MemberLoyaltyPoints', // 我的點數-紅利點數
        component: () => import('@/views/member/points/LoyaltyPoints'),
        meta: { title: '可用點數', needLogin: true }
      },
      {
        path: '/member/points-record',
        name: 'MemberPointsRecord', // 我的點數-點數紀錄
        component: () => import('@/views/member/points/PointsRecord'),
        meta: { title: '可用點數', needLogin: true }
      },
      {
        path: '/change-password',
        name: 'ChangePassword', // 修改密碼
        component: () => import('@/views/member/change-password'),
        meta: { title: '修改密碼', needLogin: true }
      },
      // orders

      {
        path: '/orders/ordersResult',
        name: 'OrdersResult', // 線上支付狀況
        component: () => import('@/views/orders/OrdersResult'),
        meta: { title: '線上支付', needLogin: true }
      },
      {
        path: '/orders/fail',
        name: 'OrdersFail', // 異常狀況
        component: () => import('@/views/orders/Fail'),
        meta: { title: '系統服務異常', needLogin: true }
      },
      {
        path: '/orders/:id',
        name: 'Orders', // 線上支付
        component: () => import('@/views/orders'),
        meta: { title: '線上支付', needLogin: true }
      },
      // ----------------
      {
        path: '/forget-password/email-idv',
        name: 'ForgetPasswordEmailIDV', // 忘記密碼：傳送至email
        component: () => import('@/views/account/forget-password/email-idv'),
        meta: { title: '忘記密碼：傳送至email', needLogin: false }
      },
      {
        path: '/forget-password/mobile-idv',
        name: 'ForgetPasswordMobileIDV', // 忘記密碼：傳送至手機
        component: () => import('@/views/account/forget-password/mobile-idv'),
        meta: { title: '忘記密碼：傳送至手機', needLogin: false }
      },
      {
        path: '/place-intro/:id',
        name: 'PlaceIntro', // 場地介紹
        component: () => import('@/views/place-intro'),
        meta: { title: '場地介紹', needLogin: false }
      },
      {
        path: '/news',
        name: 'News', // 最新消息列表
        component: () => import('@/views/news'),
        meta: { title: '最新消息列表', needLogin: false, needFooter: true }
      },
      {
        path: '/news/content/:id',
        name: 'NewsContent', // 最新消息內頁
        component: () => import('@/views/news/Content'),
        meta: { title: '最新消息內頁', needLogin: false }
      },
      {
        path: '/course-intro/:id',
        name: 'CourseIntro', // 課程介紹
        component: () => import('@/views/course-enrollment/components/CourseIntro'),
        meta: { title: '課程介紹', needLogin: false }
      },
      {
        path: '/single-course',
        name: 'SingleCourse', // 單堂課報名
        component: () => import('@/views/course-enrollment/single-course'),
        meta: { title: '單堂課報名', needLogin: false, needFooter: true }
      },
      {
        path: '/course',
        name: 'Course', // 多堂課報名
        component: () => import('@/views/course-enrollment/course'),
        meta: { title: '多堂課報名', needLogin: false, needFooter: true }
      },
      {
        path: '/venue-booking/generally',
        name: 'VenueBookingGenerally', // 臨租
        component: () => import('@/views/venue-booking/generally'),
        meta: { title: '場地預約-(一個單位)', needLogin: false, needFooter: true }
      },
      {
        path: '/venue-booking/generally/confirm',
        name: 'VenueBookingGenerallyConfirm', // 臨租確認
        component: () => import('@/views/venue-booking/generally/Confirm'),
        meta: { title: '場地預約，確認-(一個單位)', needLogin: true }
      },
      {
        path: '/venue-booking/season',
        name: 'Season', // 季租
        component: () => import('@/views/venue-booking/season'),
        meta: { title: '季租', needLogin: false, needFooter: true }
      },
      {
        path: '/venue-booking/season/confirm/:id',
        name: 'VenueBookingSeasonConfirm', // 季租預約確認
        component: () => import('@/views/venue-booking/season/Confirm'),
        meta: { title: '季租預約確認', needLogin: true }
      },
      {
        path: '/venue-booking/season/success/:id',
        name: 'VenueBookingSeasonSuccess', // 季租預約成功
        component: () => import('@/views/venue-booking/season/Success'),
        meta: { title: '季租預約成功', needLogin: true }
      },
      {
        path: '/shop',
        name: 'Shop', // 線上購買列表
        component: () => import('@/views/shop'),
        meta: { title: '線上購買', needLogin: false, needFooter: true }
      },
    ]
  },
  {
    path: '/404',
    hidden: true,
    component: () => import('@/views/404')
  },
  // 404 page must be placed at the end !!!
  {
    path: '/:catchAll(.*)',
    redirect: '/404',
    hidden: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes,
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return {
        top: 0
      }
    }
  }
})

export default router
